import React from 'react';
import { Outlet } from 'react-router-dom';
import { FloorManagerProvider } from '../context/FloorManagerContext';
import FloorManagerHeader from '../components/FloorManagerHeader';

const FloorManagerLayout = () => (
  <FloorManagerProvider>
    <FloorManagerHeader />
    <Outlet />
  </FloorManagerProvider>
);

export default FloorManagerLayout;